/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The TemplateInfoWithFolder model module.
 * @module model/TemplateInfoWithFolder
 * @version 1.0.0
 */
class TemplateInfoWithFolder {
    /**
     * Constructs a new <code>TemplateInfoWithFolder</code>.
     * @alias module:model/TemplateInfoWithFolder
     */
    constructor() { 
        
        TemplateInfoWithFolder.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>TemplateInfoWithFolder</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TemplateInfoWithFolder} obj Optional instance to populate.
     * @return {module:model/TemplateInfoWithFolder} The populated <code>TemplateInfoWithFolder</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TemplateInfoWithFolder();

            if (data.hasOwnProperty('detail')) {
                obj['detail'] = ApiClient.convertToType(data['detail'], 'String');
            }
            if (data.hasOwnProperty('url')) {
                obj['url'] = ApiClient.convertToType(data['url'], 'String');
            }
            if (data.hasOwnProperty('folder')) {
                obj['folder'] = ApiClient.convertToType(data['folder'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} detail
 */
TemplateInfoWithFolder.prototype['detail'] = undefined;

/**
 * @member {String} url
 */
TemplateInfoWithFolder.prototype['url'] = undefined;

/**
 * @member {String} folder
 */
TemplateInfoWithFolder.prototype['folder'] = undefined;






export default TemplateInfoWithFolder;

